//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { crl8 } from 'app/curalate.globals';
import {
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export function routingRules() {
  // noop
}

export const states = {
  bookmarkletframe: StateFactory({
    url: '/bookmarkletframe',
    template: componentNameToTemplate('bookmarkletPage'),
    data: {
      // Enable logged-out access to enable a custom redirect
      // for logged-out users
      allowLoggedOut: true,
      title: 'Bookmarklet',
      navGroup: NavGroup.HOME,
    },
    redirectTo: () => {
      if (!crl8.isAuthedSession()) {
        return 'loginlinkframe';
      }
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.bookmarklet-page',
        () => import('./bookmarklet-page'),
      ),
    },
  }),
  loginlinkframe: StateFactory({
    url: '/loginlinkframe',
    template: componentNameToTemplate('loginLinkPage'),
    data: {
      allowLoggedOut: true,
      title: 'Login to Bazaarvoice',
      navGroup: NavGroup.HOME,
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.login-link-page',
        () => import('./login-link-page'),
      ),
    },
  }),
};
